import React, { useEffect, useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";

import BigStorySingleCollection from "../big-story-single-collection";

import { getTotalCountOfEachCollection } from "../../helper/api";
import translate from "../../translate";

import "./bigStoryCollections.m.css";

const BigStoryCollections = ({ collection, publisherName }) => {
  const [collectionList, setCollectionList] = useState([]);

  if (!(collection && collection.items)) {
    return null;
  }

  useEffect(() => {
    const list = collection.items.filter((item) => item.type === "collection").splice(0, 4);
    const callbacks = [];

    list.forEach((element) => {
      callbacks.push(getTotalCountOfEachCollection(element.slug));
    });

    // Make bulk api calls to fetch only 2 stories along with total-count
    if (list.length) {
      Promise.all(callbacks).then((results) => setCollectionList(results));
    }
  }, []);

  if (!collectionList.length) {
    return null;
  }

  return (
    <div styleName="container">
      <div styleName="wrapper" id={collection.slug}>
        <div styleName="big-story-header-container">
          <div styleName="big-story" className="container">
            <Link href={collection.slug}>
              <span styleName="title">{collection.name}</span>
            </Link>
            <Link href={collection.slug} styleName="collection-link">
              {translate(publisherName, "see_more")}
            </Link>
          </div>
        </div>

        <div styleName="content" className="container">
          <div styleName="collection-wrapper">
            {collectionList.length &&
              collectionList.map((item, index) => (
                <BigStorySingleCollection slug={collection.slug} collection={item} key={index} />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

BigStoryCollections.propTypes = {
  collection: object.isRequired,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(BigStoryCollections);
